import type {
  RecallReminderSendApiData,
  RecallReminderSendApiResponses,
  RecallReminderSendJobStatusApiData,
  RecallReminderSendJobStatusApiResponses,
  RecallReminderSendPreviewApiData,
  RecallReminderSendPreviewApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getRecallReminderUrls = {
  postRecallRemindersSend: responseEndpoint<RecallReminderSendApiData, RecallReminderSendApiResponses>({
    getUrl: ({ serviceDepartmentId }) => apiUrl(`recalls/${serviceDepartmentId}/send-reminder/`),
    getBody: ({ reminderNumbers, reminderDelayDays, minDaysBetweenPersonSms, proposalIds }) => ({
      reminderNumbers,
      reminderDelayDays,
      minDaysBetweenPersonSms,
      proposalIds
    })
  }),
  postRecallReminderSendPreview: responseEndpoint<
    RecallReminderSendPreviewApiData,
    RecallReminderSendPreviewApiResponses
  >({
    getUrl: ({
      serviceDepartmentId,
      reminderNumbers: _reminderNumbers,
      reminderDelayDays: _reminderDelayDays,
      minDaysBetweenPersonSms: _minDaysBetweenPersonSms,
      maxProposals: _maxProposals,
      proposalIds: _proposalIds,
      ...query
    }) => apiUrl(`recalls/${serviceDepartmentId}/send-reminder/preview/`, query),
    getBody: ({ reminderNumbers, reminderDelayDays, minDaysBetweenPersonSms, maxProposals }) => ({
      reminderNumbers,
      reminderDelayDays,
      minDaysBetweenPersonSms,
      maxProposals
    })
  }),
  getRecallReminderSendJobStatus: dataEndpoint<
    RecallReminderSendJobStatusApiData,
    RecallReminderSendJobStatusApiResponses
  >({
    getUrl: ({ serviceDepartmentId, jobId }) => apiUrl(`recalls/${serviceDepartmentId}/reminder-send-job/${jobId}/`)
  })
};
